import { render, staticRenderFns } from "./StockInventoryRequirementsListDialog.vue?vue&type=template&id=8e35c098&scoped=true"
import script from "./StockInventoryRequirementsListDialog.vue?vue&type=script&lang=js"
export * from "./StockInventoryRequirementsListDialog.vue?vue&type=script&lang=js"
import style0 from "./StockInventoryRequirementsListDialog.vue?vue&type=style&index=0&id=8e35c098&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e35c098",
  null
  
)

export default component.exports